import { Link } from "react-router-dom";
import { Card, CardBody, Col } from "reactstrap";
import { H4, Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Utils";

const FriendCard = () => {
  return (
    <Col xl="3" sm="5" className="xl-30 box-col-4e">
      <Card className="offer-card">
        <CardBody>
          <div className="offer-items d-flex align-items-center">
            <div className="offer-details offer-order-1">
              <H4 className="f-w-600">Save 30% on offer all products in January.</H4>
              <Link className="btn btn-secondary" to={`${process.env.PUBLIC_URL}/applications/users/user-profile`}>Ask A friend</Link>
              <Link className="receive-link" to={`${process.env.PUBLIC_URL}/applications/email/letter-box`}>Receive Link
                <i className="icon-arrow-right ms-1" />
              </Link>
            </div>
            <Image className="offer-img" src={dynamicImage("dashboard-2/offer-profile.png")} alt="profile" />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default FriendCard;
